module.exports = __webpack_public_path__ + "img/support_d2.95f5a637.png";